import type { IconName, TagColor } from '@billy/design-system'

import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'

interface ImportedInvoiceSyncStatusTag {
  color: TagColor
  icon: IconName
  labelKey: string
  tooltipKey: string
}

export const importedInvoiceSyncStatusToTag: Record<CegidIntegrationStatus, ImportedInvoiceSyncStatusTag> = {
  [CegidIntegrationStatus.Failed]: {
    color: 'red',
    icon: 'refreshCwOff',
    labelKey: 'imported_invoices.sync_status.failed',
    tooltipKey: 'imported_invoices.sync_status.failed.tooltip',
  },
  [CegidIntegrationStatus.Pending]: {
    color: 'neutral',
    icon: 'clock',
    labelKey: 'imported_invoices.sync_status.pending',
    tooltipKey: 'imported_invoices.sync_status.pending.tooltip',
  },
  [CegidIntegrationStatus.Posted]: {
    color: 'neutral',
    icon: 'refresh',
    labelKey: 'imported_invoices.sync_status.posted',
    tooltipKey: 'imported_invoices.sync_status.posted.tooltip',
  },
  [CegidIntegrationStatus.Processing]: {
    color: 'neutral',
    icon: 'clock',
    labelKey: 'imported_invoices.sync_status.pending',
    tooltipKey: 'imported_invoices.sync_status.pending.tooltip',
  },
}
